// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__WNN8w","vertical":"Divider_vertical__vjrrW"};